import React from "react";
import { useState, useEffect } from 'react';
import ChartComponent from '../../../../components/chart';
import { Spin } from 'antd';
import Api from "../../../../services/api";
import {getBarSize, getColor, getDates} from '../../../../utility';
import ReChartComponent from "../../../../components/chartNew";

const AppChartCampaignTargetType = (props) => {
  const [loading, setLoading] = useState(false);
  const [chartCampaignTargetType, setChartCampaignTargetType] = useState([]);
  const [chartCampaignTargetTypeData, setChartCampaignTargetTypeData] = useState({
    labels: [],
    datasets: []
  });

  // const chartCampaignTargetTypeOptions = {
  //   indexAxis: 'y',
  //   elements: {
  //     bar: {
  //       borderWidth: 2,
  //     }
  //   },
  //   plugins: {
  //     legend: {
  //       display: false,
  //     },
  //     title: {
  //       display: true,
  //       position: "bottom",
  //       text: ''
  //     }
  //   }
  // };
  const chartCampaignTargetTypeOptions = {
    indexAxis: 'y',
    legend: false
  };

  useEffect(() => {
    setLoading(true)
    Api.get(`api/overview/cost_by_network?os=${props.os}&from=${props.startDate.format('YYYY-MM-DD')}&to=${props.endDate.format('YYYY-MM-DD')}&code=${props.code}&country=${props.country}&ad_network=${props.adnetwork}&campaign=${props.campaign}&index_filter=${props.filter}`)
        .then(result => {
          if (result?.data?.code === 0){
            setChartCampaignTargetType(result.data.data)
            setLoading(false)
          }
        });
  }, [props.reload, props.filter]);

  // Hàm shuffle mảng

  useEffect(() => {

    let labels = [];
    let datasets = [{
      label: `${props.startDate.format('YYYY-MM-DD')} - ${props.endDate.format('YYYY-MM-DD')}`,
      data: [],
      backgroundColor: [],
      barThickness: getBarSize
    }];

    chartCampaignTargetType.forEach((item, index) => {
      labels.push(item.name);
      datasets[0].data.push(item.value);
      datasets[0].backgroundColor.push(getColor(index))
    });

    setChartCampaignTargetTypeData({ labels, datasets });
  }, [chartCampaignTargetType]);

  return (
      <Spin spinning={loading}>
        {/* <ChartComponent type="bar" data={chartCampaignTargetTypeData} options={chartCampaignTargetTypeOptions} /> */}
        <ReChartComponent type="bar" data={chartCampaignTargetTypeData} options={chartCampaignTargetTypeOptions} />
      </Spin>
  );
};

export default AppChartCampaignTargetType;
